<div class="search-box">
  <i class="material-symbols-outlined search-box__icon"> search </i>
  <input
    type="text"
    class="search-box__input"
    (input)="handleChange($event)"
    [placeholder]="placeholder"
    [value]="value"
    />
</div>
